import * as Flags from 'country-flag-icons/react/3x2'
interface PropType {
  countryCode: keyof typeof Flags
  countryName: string
}
function CountryNameFlag(props: Readonly<PropType>) {
  const Flag = Flags[props.countryCode]
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <svg width={30} height={20}>
        {Flag ? <Flag width={30} height={20} title={props.countryName} /> : <svg />}
        <text y={40} alignmentBaseline='central' fontSize='1em'>
          {props.countryName}
        </text>
      </svg>
      <p
        style={{
          fontSize: '1.25rem',
          marginTop: '10px',
          fontWeight: '500',
          textAlign: 'center',
        }}
      >
        {props.countryName}
      </p>
    </div>
  )
}

export default CountryNameFlag
